var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentEmptyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.355 7.14a8 8 0 01-7.166 12.82L9.47 21.676c.807.21 1.655.323 2.529.323 5.523 0 10-4.477 10-10 0-2.38-.832-4.567-2.221-6.285l1.847-1.847-1.415-1.414L5.716 16.951a8 8 0 017.249-12.893l1.699-1.7A10.01 10.01 0 0012 2C6.477 2 2 6.477 2 12a9.96 9.96 0 002.293 6.373l-1.839 1.839 1.414 1.414L18.355 7.139z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEmptyOutline);
export default __webpack_public_path__ + "898b10175ccc16219f73306d71545afc.svg";
export { ForwardRef as ReactComponent };